import { nanoid } from 'nanoid';

export type PKCECodePair = {
  codeVerifier: string;
  codeChallenge: string;
  createdAt: Date;
};

export const base64URLEncode = (str: string): string => {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const sha256 = async (str: string): Promise<string> => {
  const buffer = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

export const createPKCECodes = async (): Promise<PKCECodePair> => {
  const codeVerifier = base64URLEncode(nanoid(64));
  const codeChallenge = base64URLEncode(await sha256(codeVerifier));
  const createdAt = new Date();
  return {
    codeVerifier,
    codeChallenge,
    createdAt,
  };
};

export let pkceCodes: PKCECodePair;

(async () => {
  pkceCodes = await createPKCECodes();
})();
